export default __webpack_public_path__ + "static/media/drop-down-arrow.ef6fce08.svg";